document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('calcCatalogSearch');
    const emptyState = document.getElementById('calcCatalogEmpty');
    const resetButton = document.getElementById('calcCatalogReset');
    const items = document.querySelectorAll('.calc-catalog-item');
    const sections = document.querySelectorAll('.calc-catalog-section');

    if (!searchInput) return;

    function applyFilter() {
        const query = searchInput.value.trim().toLowerCase();
        let totalVisible = 0;

        items.forEach(function (item) {
            const text = item.textContent.toLowerCase();
            const matches = !query || text.includes(query);
            item.classList.toggle('d-none', !matches);
            if (matches) {
                totalVisible++;
            }
        });

        sections.forEach(function (section) {
            const hasVisibleItems = section.querySelector('.calc-catalog-item:not(.d-none)') !== null;
            section.classList.toggle('d-none', !hasVisibleItems);
        });

        const ukraine = document.querySelector('[data-calc-ukraine]');
        if (ukraine && query) {
            ukraine.open = ukraine.querySelector('.calc-catalog-item:not(.d-none)') !== null;
        }

        if (emptyState) {
            emptyState.classList.toggle('d-none', totalVisible > 0);
        }
    }

    searchInput.addEventListener('input', applyFilter);

    if (resetButton) {
        resetButton.addEventListener('click', function () {
            searchInput.value = '';
            applyFilter();
            searchInput.focus();
        });
    }
});

